export default {
      id: "menu__proHub-usage",
      viewBox: "0 0 38 38",
      url: __webpack_public_path__ + "img/icons.svg#menu__proHub",
      toString: function () {
        return this.url;
      }
    }